import { TableCellHeader } from './TableCellHeader';

export * from './TableCellHeader.types';

export default TableCellHeader;
